import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function BirthCertificateListingContent({
  handleAddModal,
  handleViewImage,
  handleEdit,
  userManagementId,
  showBirthCertificate,
  userManagementInfo,
}) {
  useEffect(() => {
    if (_.isEmpty(userManagementId)) return;
    showBirthCertificate(userManagementId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(userManagementId)) return;
    showBirthCertificate(userManagementId);
  }, [userManagementId]);

  const hasImages = _.get(userManagementInfo, 'included.images') || [];
  return (
    <div className="container-fluid card-section-content">
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
          >
            Add &nbsp;&nbsp;
            <i className="fas fa-plus" />
          </button>
        </div>
      </div>
      {!_.isEmpty(userManagementInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Record Information</h3>
                <div>
                  {hasImages.length ? (
                    <button
                      type="button"
                      className="btn btn-warning mr-2"
                      onClick={handleEdit(userManagementInfo)}
                    >
                      Edit Record
                    </button>
                  ) : (
                    ''
                  )}
                  <button
                    type="button"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2"
                    onClick={handleViewImage(userManagementInfo, 'FRONT')}
                  >
                    Show Front
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary "
                    onClick={handleViewImage(userManagementInfo, 'BACK')}
                  >
                    Show Back
                  </button>
                </div>
              </div>
              <hr />
              <div className="mt-4">
                <div className="row d-flex justify-content-center">
                  <div className="col">
                    <table className="table table-striped table-borderless">
                      <tbody>
                        <tr>
                          <th className="table-title">Registry Number:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.registry_number'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">First Name:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.first_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Middle Name:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.middle_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Last Name:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.last_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Extension Name:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.extension_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Birth Date:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.birth_date'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">
                            Mother&apos;s First Name:
                          </th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.mothers_first_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">
                            Mother&apos;s Last Name:
                          </th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.mothers_last_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">
                            Mother&apos;s Middle Name:
                          </th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.mothers_middle_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Place of Birth:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.birth_place'
                            ) || '--'}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

BirthCertificateListingContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleViewImage: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,

  showBirthCertificate: PropTypes.instanceOf(Function).isRequired,
  userManagementInfo: PropTypes.instanceOf(Object).isRequired,
  userManagementId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  userManagementInfo: _.get(api, `${c.GET_SINGLE_USER_MANAGEMENT}.item`) || {},
  userManagementId: _.get(match, 'params.userManagementId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BirthCertificateListingContent);
